<!--资源中心-->
<template>
    <div class="container">
        <div class="wel-box">
            <div class="top-box">
                <homeHead ref="homeHead" />
            </div>
            <div class="course-container">
                <div class="left-menu-container">
                    <course-menu :item-num="this.activeItem"
                                 @change-item="changeItem"/>
                </div>
                <!--高水平示范课-->
                <div v-if="activeItem==='1'"  class="right-content-container">
                    <page-course title="高水平示范课"
                                 courseType="1"
                                 :course-mode="this.activeMode"
                                 @change-mode="changeMode"/>
                </div>
                <!--区本课程-->
                <div v-if="activeItem==='2'"  class="right-content-container">
                    <page-course title="区本课程"
                                 courseType="2"
                                 :course-mode="this.activeMode"
                                 @change-mode="changeMode"/>
                </div>
                <!--校本课程-->
                <div v-if="activeItem==='3'"  class="right-content-container">
                    <page-course title="校本课程"
                                 courseType="3"
                                 :course-mode="this.activeMode"
                                 @change-mode="changeMode"/>
                </div>
                <!--课后服务-->
                <div v-if="activeItem==='4'"  class="right-content-container">
                    <page-service-course title="课后服务"
                                 courseType="4"
                                 :course-mode="this.activeMode"
                                 @change-mode="changeMode"/>
                </div>
                <!--人工智能-->
                <div v-if="activeItem==='5'"  class="right-content-container">
                    <page-course title="人工智能"
                                 courseType="5"
                                 :course-mode="this.activeMode"
                                 @change-mode="changeMode"/>
                </div>
                <!--互动课件-->
                <div v-if="activeItem==='6'"  class="right-content-container">
                    <courseware-list title="互动课件"
                                     :course-mode="this.activeMode"
                                     @change-mode="changeMode"/>
                </div>
                <!--人文美育-->
                <div v-if="activeItem==='8'"  class="right-content-container">
                    <humanity-museum-home title="人文美育"
                                     :course-mode="this.activeMode"
                                     @change-mode="changeMode"/>
                </div>
                <!--党建引领-->
                <div v-if="activeItem==='10'"  class="right-content-container">
                    <djyl-resource-new title="党建引领"
                                   :course-mode="this.activeMode"
                                   @change-mode="changeMode"/>
                </div>
                <!--政策法规-->
                <div v-if="activeItem==='11'"  class="right-content-container">
                    <zcfg-resource title="政策法规"
                                   :course-mode="this.activeMode"
                                   @change-mode="changeMode"/>
                </div>
                <!--五馆合一-旧-->
                <div v-if="activeItem==='12'"  class="right-content-container">
                    <humanity-five-museum-edit title="五馆合一"
                                          :course-mode="this.activeMode"
                                          @change-mode="changeMode"/>
                </div>
                <!--跨学科融合-->
                <div v-if="activeItem==='13'"  class="right-content-container">
                    <humanity-subject-museum title="跨学科融合"
                                          :course-mode="this.activeMode"
                                          @change-mode="changeMode"/>
                </div>
                <!--美育浸润-->
                <div v-if="activeItem==='14'"  class="right-content-container">
                    <home-myjr title="美育浸润"
                               :course-mode="this.activeMode"
                               @change-mode="changeMode"/>
                </div>
                <!--恒岳阅读-->
                <div v-if="activeItem==='15'"  class="right-content-container">
                    <home-read title="恒岳阅读"
                               :course-mode="this.activeMode"
                               @change-mode="changeMode"/>
                </div>

                <!--初中题库（日清周结）-->
                <div v-if="activeItem==='24'"  class="right-content-container">
                    <rqzj-home title="日清周结"
                               :course-mode="this.activeMode"
                               @change-mode="changeMode"/>
                </div>
                <!--高中题库（三层量分定做）-->
                <div v-if="activeItem==='25'"  class="right-content-container">
                    <sclfdz-home title="三层量分定做"
                                 :course-mode="this.activeMode"
                                 @change-mode="changeMode"/>
                </div>
                <!-- 新五馆合一-->
                <div v-if="activeItem==='30'"  class="right-content-container">
                    <new-five-museum
                                          :course-mode="this.activeMode"
                                          @change-mode="changeMode"/>
                </div>

                <!-- 新五馆-阅读拓展馆-->
                <div v-if="activeItem==='31'"  class="right-content-container">
                    <read-extension-museum
                      :course-mode="this.activeMode"
                      :is-show-back="false"
                      @change-mode="changeMode"/>
                </div>
                <!-- 新五馆-科技艺术馆-->
                <div v-if="activeItem==='32'"  class="right-content-container">
                    <tech-art-museum
                      :course-mode="this.activeMode"
                      :is-show-back="false"
                      @change-mode="changeMode"/>
                </div>

                <!-- 新五馆-非遗文化馆-->
                <div v-if="activeItem==='33'"  class="right-content-container">
                    <intangible-museum
                      :course-mode="this.activeMode"
                      :is-show-back="false"
                      @change-mode="changeMode"/>
                </div>

                <!-- 新五馆-劳动实践馆-->
                <div v-if="activeItem==='34'"  class="right-content-container">
                    <labor-practice-museum
                      :course-mode="this.activeMode"
                      :is-show-back="false"
                      @change-mode="changeMode"/>
                </div>

                <!-- 新五馆-自然研学馆-->
                <div v-if="activeItem==='35'"  class="right-content-container">
                    <nature-study-museum
                      :course-mode="this.activeMode"
                      :is-show-back="false"
                      @change-mode="changeMode"/>
                </div>

            </div>
        </div>
    </div>
</template>
<script>
import {timestampToTime} from "@/utils/date";
import {serviceWebUrl} from "@/utils/global";
import homeHead from "@/components/homeHead.vue";
import homeFooter from "@/components/homeFooter";
import dataEmpty from "@/components/dataEmpty.vue";
import courseMenu from "@/components/resourceCentre/courseMenu";
import courseMenuOld from "@/components/resourceCentre/courseMenuOld.vue";
import pageCourse from "@/components/resourceCentre/pageCourse";
import pageServiceCourse from "@/components/resourceCentre/pageServiceCourse.vue";
import coursewareList from "@/components/resourceCentre/coursewareList";
import humanityMuseumHome from "@/components/resourceCentre/humanityMuseumHome";
import humanityFiveMuseum from "@/components/resourceCentre/humanityFiveMuseum.vue";
import humanityFiveMuseumEdit from "@/components/resourceCentre/humanityFiveMuseumEdit.vue";
import humanitySubjectMuseum from "@/components/resourceCentre/humanitySubjectMuseum.vue";
import djylResource from "@/components/resourceCentre/djylResource.vue";
import djylResourceNew from "@/components/resourceCentre/djylResourceNew.vue";
import zcfgResource from "@/components/resourceCentre/zcfgResource.vue";
import {oauthCode} from "@/api/user/login";
import DjylResourceNew from "@/components/resourceCentre/djylResourceNew.vue";
import homeMyjr from "@/components/myjr/homeMyjr.vue";
import homeRead from "@/components/read/homeRead.vue";

import newFiveMuseum from "@/components/newMuseum/newFiveMuseum.vue";
import readExtensionMuseum from "@/components/newMuseum/readExtensionMuseum.vue";
import techArtMuseum from "@/components/newMuseum/techArtMuseum.vue";
import intangibleMuseum from "@/components/newMuseum/intangibleMuseum.vue";
import laborPracticeMuseum from "@/components/newMuseum/laborPracticeMuseum.vue";
import natureStudyMuseum from "@/components/newMuseum/natureStudyMuseum.vue";
import HumanityFiveMuseumEdit from "@/components/resourceCentre/humanityFiveMuseumEdit.vue";

import rqzjHome from "@/components/rqzj/rqzjHome.vue";
import sclfdzHome from "@/components/sclfdz/sclfdzHome.vue";

export default {
    components: {
        HumanityFiveMuseumEdit,
        natureStudyMuseum,
        laborPracticeMuseum,
        intangibleMuseum,
        techArtMuseum,
        DjylResourceNew,
        pageCourse,
        courseMenu,
        courseMenuOld,
        dataEmpty,
        homeHead,
        homeFooter,
        coursewareList,
        humanityMuseumHome,
        humanityFiveMuseum,
        humanitySubjectMuseum,
        pageServiceCourse,
        zcfgResource,
        djylResource,
        homeMyjr,
        homeRead,
        newFiveMuseum,
        readExtensionMuseum,
        rqzjHome,
        sclfdzHome
    },
    name: "homeResourceCentre",
    data() {
        return {
            serviceWebUrl,
            pageMode:"page",
            detailMode:"detail",
            timestampToTime,
            activePath: "homeResourceCentre",
            activeItem:"1",
            activeMode:"page",
            userInfo: {},
        }
    },
    computed: {},
    watch: {},
    created() {
        this.userInfo = JSON.parse(this.$storage.get("userInfo"))
    },
    mounted() {
        this.$refs.homeHead.activePath = this.activePath;
    },
    methods: {
        changeItem(item){
            if (item==='7'){
                if (!this.userInfo.isAide) {
                    this.$message.error("暂无权限")
                } else {
                    oauthCode({
                        clientId: 'xhly2024855631', username: this.userInfo.username
                    }).then(res => {
                        if (res.data.data) {
                            window.open('https://web.edumate.cn/thirdpart?platform=sxdtjz&code=' + res.data.data + '&client_id=xhly2024855631&response_type=code', '_blank')
                        } else {
                            this.$message.error("授权失败")
                        }
                    })
                }
                return;
            }
            if (item==='9'){
                window.open('https://basic.smartedu.cn/', '_blank')
                return;
            }
            if (item==='20'){
                window.open('https://m.boyameiyu.com/', '_blank')
                return;
            }
            if (item==='21'){
                // window.open('https://www.xj5u.com/Indexs.aspx', '_blank')
                window.open('http://www.xj5u.com/Handler/Login.ashx?ticket=hengyuejy', '_blank')
                return;
            }
            if (item==='22'){
                window.open('http://www.zk5u.com/Handler/Login.ashx?ticket=hengyuejy', '_blank')
                return;
            }
            if (item==='23'){
                window.open('https://apistore.ks5u.com/?GUID=7618FCD48C4D02AF0D256BBAFAB0C3BC&TYPE=NEW', '_blank')
                return;
            }
            if (item==='26'){
                window.open('https://chs.xwjyd.com/mall/subpages/mall/pages/shelves/shelves?sid=100104848&id=97289&advId=15073107777&promote=15073107777', '_blank')
                return;
            }
            if (item==='27'||item==='28'||item==='29'){
                let sp = "1";
                if (item==='28'){
                    sp = "2";
                }
                if (item==='29'){
                    sp = "3";
                }
                this.$router.push({
                    path: "/hyedu/ques",
                    query: {
                        sp: sp,
                    }
                });
                return;
            }
            this.activeItem = item;
            this.activeMode = this.pageMode;
            this.$store.commit("params/setJumpParams", {});
        },
        changeMode(mode){
            this.activeMode = mode;
        }
    }
}
</script>
<style scoped>
.container {
    width: 100%;
    height: 100%;
    margin: 0;
    overflow-y: auto!important;
    overflow-x: hidden;
    background-color: #f1f1f1;
}
.wel-box {
    width:100vw;
    height: auto;
    overflow-y: auto!important;
    .top-box{
        display: flex;
        width: 100vw;
        height: 70px;
    }
}
.course-container{
    width: 100%;
    height: auto;
    border: 10px;
    box-sizing: border-box;
    display: flex;
}
.left-menu-container{
    width: 200px;
    height: auto;
    padding: 10px;
    box-sizing: border-box;
}
.right-content-container{
    width: calc(100% - 200px);
    height: auto;
    padding: 10px;
    box-sizing: border-box;
}
</style>